import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "squars",
  "use": "squars-usage",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" id=\"squars\">\n    <defs>\n          <pattern id=\"squars_secondPattern\" x=\"2\" y=\"2\" width=\"10\" height=\"10\" patternUnits=\"userSpaceOnUse\">\n              <rect x=\"5\" y=\"5\" width=\"10\" height=\"10\" fill=\"#e1e1e1\" fill-opacity=\"0.4\" />\n          </pattern>\n    </defs>\n    <rect x=\"2\" y=\"2\" width=\"100%\" height=\"100%\" fill=\"url(#squars_secondPattern)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol